import React, { useEffect, useState } from "react";
import SingleJobCard from "../../../components/items/SingleJobCard";
import Button from "../../form/front/Button";
import Select from "../../form/front/Select";
import SearchWithDropdown from "../../form/front/SearchWithDropdown";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { jobDetailsUser, jobUserList } from "../../../services/postService";
import Modal from "../../elements/front/Modal";
import Input from "../../form/front/Input";
import Textarea from "../../form/front/Textarea";
import JobDetailsCard from "./JobDetailsCard";
import JobDetailsSkeleton from "../../skeleton/JobDetailsSkeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import DatePicker from "../../form/DatePicker";
import Checkbox from "../../form/front/Checkbox";
import Radio from "../../form/front/Radio";
import FileUploadSingle from "../../form/FileUploadSingle";
import useForm from "../../../hooks/useForm";
import { applyJob } from "../../../services/applicationService";
import { toast } from "react-toastify";
import { formValidate } from "../../../helpers/formValidate";
import Form from "../../form/Form";
import { taxonomyList } from "../../../services/taxonomyService";
import { useDebounce } from "../../../hooks/useDebounce";
import PaginationPage from "../../common/Pagination";
import AboutCompany from "./AboutCompany";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const JobSection = () => {
  const [gender, setGender] = useState("male");
  const [agree, setAgree] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isState, setisState] = useState(null);
  const [selectSort, setSelectSort] = useState(null);
  const [experience, setExperience] = useState(null);
  const [companyType, setCompanyType] = useState([]);
  const [jobType, setJobType] = useState(null);
  const [salary, setSalary] = useState(null);
  const [skills, setSkills] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [eeo, setEeo] = useState([]);
  const [sex, setSex] = useState("");
  const [veteranStatus, setVeteranStatus] = useState("");
  const [disability, setDisability] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const location = useLocation();
  /* ---------------- JOB SEARCH STATE ---------------- */
  const [keyword, setKeyword] = useState("");
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  /* ---------------- COUNTRY / STATE SEARCH STATE ---------------- */
  const [countryKeyword, setCountryKeyword] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  // -----------------------Cart Mobile---------------------
  const [showJobMobile, setShowJobMobile] = useState(false)


  /* ---------------- RESPONSIVE DETECTION ---------------- */
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  /* ---------------- STATIC COUNTRY / STATE DATA ---------------- */
  const countryStateData = [
    { _id: "c1", type: "list", name: "India" },
    { _id: "c2", type: "list", name: "United States" },
    { _id: "c3", type: "list", name: "United Kingdom" },
    { _id: "c4", type: "list", name: "Canada" },
    { _id: "c5", type: "list", name: "Australia" },
    { _id: "c6", type: "list", name: "California, USA" },
    { _id: "c7", type: "list", name: "New York, USA" },
    { _id: "c8", type: "list", name: "Maharashtra, India" },
    { _id: "c9", type: "list", name: "Karnataka, India" },
  ];
  const { slug } = useParams();
  const navigate = useNavigate();
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orgSlug = params.get("organization");

    if (orgSlug) {
      setCompanyType([orgSlug]); // important → ARRAY format
    }
  }, [location.search]);
  const [filters, setFilters] = useState({
    limit: 20,
    page: 1,
    sortQuery: "-createdAt",
  });
  const { data, isLoading, isError, error, isFetching } = useQuery({
    queryKey: [
      "job-list",
      filters,
      search,
      experience,
      jobType,
      salary,
      skills,
      startDate,
      endDate,
      companyType,
    ],
    queryFn: async () => {
      const res = await jobUserList({
        ...filters,

        ...(search && { keyword: search }),
        ...(experience && { experience }),
        ...(jobType && { jobType }),
        ...(salary && { salary }),
        ...(skills && { skills }),
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
        ...(companyType?.length > 0 && { organization: companyType }),
      });

      if (res?.status !== 200) {
        toast.warning(res?.message);
      }

      return res;
    },
    keepPreviousData: true,
  });
  const paginationMeta = data?.docs?.metadata;

  const totalPages = paginationMeta?.totalPages || 1;

  // Pagination component is ZERO-based
  const currentPage = (paginationMeta?.page || 1) - 1;

  const jobsData = data?.docs?.data || [];
  const handlePageChange = ({ selected }) => {
    setFilters((prev) => ({
      ...prev,
      page: selected + 1, // API is 1-based
    }));
  };

  useEffect(() => {
    if (jobsData.length > 0) {
      if (!selectedJob || !jobsData.find((job) => job._id === selectedJob.id)) {
        const firstJob = jobsData[0];
        setSelectedJob({
          id: firstJob._id,
          slug: firstJob.slug,
          image: firstJob.organization?.logo?.url,
          title: firstJob.content?.en?.title,
          subtitle: firstJob.organization?.content?.en?.title,
          description: firstJob?.organization?.content?.en?.content,
          jobType: firstJob.job?.jobType,
          workMode: firstJob.locationType,
          organization: firstJob?.organization?._id,
        });
      }
    } else {
      setSelectedJob(null);
    }
  }, [jobsData]);
  useEffect(() => {
    if (slug && jobsData.length > 0) {
      const matchedJob = jobsData.find((job) => job.slug === slug);

      if (matchedJob) {
        setSelectedJob({
          id: matchedJob._id,
          slug: matchedJob.slug,
          image: matchedJob.organization?.logo?.url,
          title: matchedJob.content?.en?.title,
          subtitle: matchedJob.organization?.content?.en?.title,
          description: matchedJob?.organization?.content?.en?.content,
          jobType: matchedJob.job?.jobType,
          workMode: matchedJob.locationType,
          organization: matchedJob?.organization?._id,
        });
      }
    }
  }, [slug, jobsData]);
  /* ---------------- SELECTED JOB DETAILS ---------------- */
  const activeSlug = slug || selectedJob?.slug;
  const { data: jobDetails, isLoading: isDetailsLoading } = useQuery({
    queryKey: ["job-details", activeSlug],
    queryFn: async () => {
      if (!activeSlug) return null;
      const res = await jobDetailsUser({ id: activeSlug });
      return res;
    },
    enabled: !!activeSlug,
  });

  /* ---------------- JOB FILTER LOGIC ---------------- */
  useEffect(() => {
    if (!keyword) {
      setFilteredJobs([]);
      return;
    }

    // const filtered = searchJobsData.filter((job) =>
    //   job.name.toLowerCase().includes(keyword.toLowerCase()),
    // );
  }, [keyword]);

  /* ---------------- COUNTRY FILTER LOGIC ---------------- */
  useEffect(() => {
    if (!countryKeyword) {
      setFilteredCountries([]);
      return;
    }

    const filtered = countryStateData.filter((item) =>
      item.name.toLowerCase().includes(countryKeyword.toLowerCase()),
    );

    setFilteredCountries(filtered);
  }, [countryKeyword]);
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
    }));
  }, [search, experience, jobType, salary, skills, startDate, endDate]);
  useEffect(() => {
    const handleGlobalSearch = (event) => {
      const { keyword, startDate, endDate, companyId } = event.detail;

      setKeyword(keyword || "");
      setStartDate(startDate || null);
      setEndDate(endDate || null);
      setCompanyType(Array.isArray(companyId) ? companyId : []);
    };

    window.addEventListener("global-job-search", handleGlobalSearch);

    return () => {
      window.removeEventListener("global-job-search", handleGlobalSearch);
    };
  }, []);
  const handleJobSelect = (job) => {
    setSelectedJob(job);
    setShowJobMobile(true)

    // 👇 Update URL like LinkedIn
    navigate(`/job/${job.slug}`);
  };

  const handleCountrySelect = (item) => {
    setSelectedCountry(item);
    setCountryKeyword(item?.name || "");
  };

  const sortOptions = [
    { value: "-createdAt", name: "Latest" },
    { value: "+createdAt", name: "Oldest" },

    { value: "+content.en.title", name: "A-Z" },
    { value: "-content.en.title", name: "Z-A" },
  ];

  const { data: jobExperienceData } = useQuery({
    queryKey: ["experience"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 100,
        type: "experience",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const jobTypeOptions = [
    { value: "full-time", name: "Full Time" },
    { value: "part-time", name: "Part Time" },
    { value: "contract", name: "Contract" },
    { value: "internship", name: "Internship" },
    { value: "remote", name: "Remote" },
  ];

  const { data: salaryData } = useQuery({
    queryKey: ["salary"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "salary-range",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });
  const salaryOptions = salaryData?.data?.map((item) => {
    const unitSymbol = item?.range?.unit === "usd" ? "$" : "₹";

    const formatValue = (val) => (val >= 1000 ? `${val / 1000}k` : val);

    return {
      name: `${unitSymbol}${formatValue(
        item?.range?.min,
      )} - ${unitSymbol}${formatValue(item?.range?.max)}`,
      value: item?._id,
    };
  });

  const { data: jobSkillData } = useQuery({
    queryKey: ["skill"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "skill",
      });

      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });
  const InlineSpinner = () => (
    <i className="fa-solid fa-spinner-third animate-spin text-gray-400 ml-2" />
  );

  /* ---------------- RENDER JOB CARDS ---------------- */
  const renderJobCards = () => {
    if (isLoading) {
      return (
        <div className="space-y-4">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
            <JobCardSkeleton key={item} />
          ))}
        </div>
      );
    }

    if (isError) {
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-red-50 rounded-lg">
          <i className="fa-solid fa-circle-exclamation text-4xl text-red-500 mb-3"></i>
          <h3 className="text-lg font-semibold text-red-700 mb-1">
            Error Loading Jobs
          </h3>
          <p className="text-sm text-red-600 text-center">{error.message}</p>
        </div>
      );
    }

    if (jobsData.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-slate-50 dark:bg-white/10 dark:border dark:border-gray-500 rounded-lg">
          <i className="fa-solid fa-briefcase text-4xl text-slate-300 dark:text-gray-300 mb-3"></i>
          <h3 className="text-lg font-semibold text-slate-700 dark:text-gray-200 mb-1">
            No Jobs Found
          </h3>
          <p className="text-sm text-slate-500 dark:text-gray-300 text-center">
            Try adjusting your filters to see more results
          </p>
        </div>
      );
    }

    // Render with Swiper for mobile/tablet (<=1024px)
    // if (isMobile) {
    //   return (
    //     <div className="job-swiper-container">
    //       <Swiper
    //         modules={[Navigation, Pagination, Mousewheel, Keyboard]}
    //         spaceBetween={16}
    //         slidesPerView={1}
    //         navigation={{
    //           nextEl: ".swiper-button-next-custom",
    //           prevEl: ".swiper-button-prev-custom",
    //         }}
    //         mousewheel={{
    //           forceToAxis: true,
    //         }}
    //         keyboard={{
    //           enabled: true,
    //         }}
    //         breakpoints={{
    //           640: {
    //             slidesPerView: 1.5,
    //             spaceBetween: 16,
    //           },
    //           768: {
    //             slidesPerView: 2,
    //             spaceBetween: 20,
    //           },
    //         }}
    //         className="pb-12"
    //       >
    //         {jobsData.map((job) => (
    //           <SwiperSlide key={job._id}>
    //             <SingleJobCard
    //               data={{
    //                 id: job._id,
    //                 slug: job.slug,
    //                 image: job.organization?.logo?.url,
    //                 title: job.content?.en?.title,
    //                 subtitle: job.organization?.content?.en?.title,
    //                 description: job?.organization?.content?.en?.content,
    //                 jobType: job.job?.jobType,
    //                 workMode: job.locationType,
    //                 organization: job?.organization?._id,
    //               }}
    //               onClick={handleJobSelect}
    //               isSelected={selectedJob?.id === job._id}
    //             />
    //           </SwiperSlide>
    //         ))}
    //       </Swiper>

    //       {/* Custom Navigation Buttons */}
    //       <div className="flex items-center justify-center gap-4 mt-4">
    //         <button className="swiper-button-prev-custom w-10 h-10 rounded-full bg-palatte text-white flex items-center justify-center hover:bg-palatte/90 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
    //           <i className="fa-solid fa-chevron-left"></i>
    //         </button>
    //         <button className="swiper-button-next-custom w-10 h-10 rounded-full bg-palatte text-white flex items-center justify-center hover:bg-palatte/90 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
    //           <i className="fa-solid fa-chevron-right"></i>
    //         </button>
    //       </div>
    //     </div>
    //   );
    // }

    // Render normal list for desktop (>1024px)
    return (
      <div className="space-y-3 md:space-y-5 md:max-h-[calc(180vh-200px)] md:overflow-auto md:pr-2 scrollbar">
        {/* <div className="space-y-5 max-h-[140vh] overflow-auto pr-2 scrollbar"> */}
        {jobsData.map((job) => (
          <SingleJobCard
            key={job._id}
            data={{
              id: job._id,
              slug: job.slug,
              image: job.organization?.logo?.url,
              title: job.content?.en?.title,
              subtitle: job.organization?.content?.en?.title,
              description: job?.organization?.content?.en?.content,
              jobType: job.job?.jobType,
              workMode: job.locationType,
              organization: job?.organization?._id,
            }}
            onClick={handleJobSelect}
            isSelected={selectedJob?.id === job._id}
          />
        ))}
      </div>
    );
  };

  //Job Apply

  const validation = {
    firstName: { required: true, message: "Full name is required" },
    email: { required: true, message: "Email is required" },
    phone: { required: true, message: "Phone number is required" },
    signature: { required: true, message: "Signature is required" },
  };

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
  } = useForm({
    validationRules: validation,
    initialState: {
      // other fields...
      workExperience: [
        {
          employer: "",
          jobTitle: "",
          phone: "",
          startDate: "",
          endDate: "",
          supervisorName: "",
          supervisorPhone: "",
          certifications: "",
          address: {
            name: "",
            address1: "",
            city: "",
            state: "",
            zipcode: "",
          },
        },
      ],
      education: [
        // 0 — High School (always present)
        {
          level: "highSchool",
          instituteName: "",
          degree: "",
          type: "",
          yearPass: "",
          notes: "",
        },

        // 1 — First Institution (optional, add more)
        {
          level: "institution",
          instituteName: "",
          degree: "",
        },
      ],
      references: [
        {
          name: "",
          relationship: "",
          title: "",
          phone: "",
          email: "",
        },
        {
          name: "",
          relationship: "",
          title: "",
          phone: "",
          email: "",
        },
        {
          name: "",
          relationship: "",
          title: "",
          phone: "",
          email: "",
        },
      ],
    },
  });

  const { mutate: submitApplication, isPending } = useMutation({
    mutationFn: async (val) => {
      return await applyJob({
        attachments: resumeFile ? [resumeFile] : [],

        job: selectedJob?.id,
        organization: selectedJob?.organization,
        jobMode: "standard",
        status: "submitted",

        applicant: {
          firstName: val?.firstName,
          lastName: val?.firstName,
          email: val?.email,
          phone: {
            fullNumber: val?.phone,
          },
          alternatePhone: {
            fullNumber: val?.alternatePhone,
          },
          dateAvailable: val?.dateAvailable,
          availability: {
            Mon: val?.monHours ? { hours: Number(val.monHours) } : undefined,
            Tue: val?.tueHours ? { hours: Number(val.tueHours) } : undefined,
            Wed: val?.wedHours ? { hours: Number(val.wedHours) } : undefined,
            Thu: val?.thuHours ? { hours: Number(val.thuHours) } : undefined,
            Fri: val?.friHours ? { hours: Number(val.friHours) } : undefined,
            Sat: val?.satHours ? { hours: Number(val.satHours) } : undefined,
            Sun: val?.sunHours ? { hours: Number(val.sunHours) } : undefined,
          },
          willingToRelocate: val?.willingToRelocate,
        },

        address: {
          address1: val?.address,
        },

        workExperience: (Array.isArray(values.workExperience)
          ? values.workExperience
          : []
        )
          .filter((w) => w.employer)
          .map((w) => ({
            employer: w.employer,
            jobTitle: w.jobTitle,
            phone: w.phone,
            startDate: w.startDate,
            endDate: w.endDate,
            supervisorName: w.supervisorName,
            supervisorPhone: w.supervisorPhone,
            certifications: w.certifications,
            address: {
              name: w.address.name,
              address1: w.address.address1,
              city: w.address.city,
              state: w.address.state,
              zipcode: w.address.zipcode,
            },
          })),

        education: (Array.isArray(values.education) ? values.education : [])
          .filter((e) => e.instituteName)
          .map((e, index) =>
            index === 0
              ? {
                instituteName: e.instituteName,
                degree: e.degree,
                type: e.type,
                yearPass: e.yearPass,
                notes: e.notes,
              }
              : {
                instituteName: e.instituteName,
                degree: e.degree,
              },
          ),

        // softSkills: {
        //   questions: Array.from({ length: 10 }).map((_, i) => ({
        //     question: `Q${i + 1}`,
        //     answer: val?.[`softSkill_${i}`],
        //   })),
        // },
        softSkills: {
          questions: [
            {
              question:
                "Describe one time you disagreed with a teammate and how the issue was resolved.",
              answer: val?.softSkill_0,
            },
            {
              question:
                "What did you teach yourself outside your role in the last 12 months, and how did you apply it?",
              answer: val?.softSkill_1,
            },
            {
              question:
                "Describe a time you reported a risky practice at work and the outcome.",
              answer: val?.softSkill_2,
            },
            {
              question:
                "If instructed to skip a due-diligence step to meet a deadline, what would you do?",
              answer: val?.softSkill_3,
            },
            {
              question:
                "Rate 1-5 ability to stay productive without supervision and explain one tactic.",
              answer: val?.softSkill_4,
            },
            {
              question:
                "Give an example of tailoring communication to help a non-technical colleague.",
              answer: val?.softSkill_5,
            },
            {
              question: "Recent project mistake and first corrective action.",
              answer: val?.softSkill_6,
            },
            {
              question:
                "Single opening sentence to ask resources from an overloaded team.",
              answer: val?.softSkill_7,
            },
            {
              question: "Describe escalating a concern others had not noticed.",
              answer: val?.softSkill_8,
            },
            {
              question: "Professional goal you set and progress to-date.",
              answer: val?.softSkill_9,
            },
          ],
        },

        // confidentialInfo: {
        //   eeoClassification: eeo,
        //   sex,
        //   veteranStatus,
        //   disabilityStatus: disability,
        //   signature: val?.signature,
        //   signatureDate: val?.signatureDate,
        // },
        confidentialInfo: {
          eeoClassification: eeo, // array of strings
          sex, // male | female | non-binary | not-to-say
          veteranStatus, // veteran | not-veteran | not-to-say
          disabilityStatus: disability, // yes | no | not-to-say
          signature: val?.signature || null,
          signatureDate: val?.signatureDate || null,
        },

        references: (Array.isArray(values.references) ? values.references : [])
          .filter((r) => r.name)
          .map((r) => ({
            name: r.name,
            relationship: r.relationship,
            title: r.title,
            phone: r.phone,
            email: r.email,
          })),
      });
    },

    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message || "Application submitted successfully");
        // ✅ Update React Query cache
        queryClient.setQueryData(
          ["job-details", selectedJob?.slug],
          (oldData) => {
            if (!oldData) return oldData;

            return {
              ...oldData,
              data: {
                ...oldData.data,
                applyJob: true, // 🔥 mark as applied
              },
            };
          },
        );
        // 🔹 Reset form values
        resetField();

        // 🔹 Reset local states
        setResumeFile(null);
        setExperience("");
        setEeo([]);
        setSex("");
        setVeteranStatus("");
        setDisability("");
        setIsModalOpen(false);
      } else {
        toast.error(res?.message || res?.error || "Something went wrong");
      }
    },

    onError: () => {
      toast.error("Failed to submit application");
    },
  });
  const handleResetFilters = () => {
    // Reset search input
    setKeyword("");
    //  setSearch(""); // if you want to reset debounced keyword
    setCountryKeyword("");
    setSelectedCountry(null);

    // Reset filters
    setExperience(null);
    setCompanyType(null);
    setJobType(null);
    setSalary(null);
    setSkills(null);
    setSelectSort(null);

    // Reset query filters
    setFilters({
      limit: 20,
      page: 1,
      sortQuery: "-createdAt",
    });
  };

  return (
    <>
      <section className="md:pb-14 xls:pb-28 bg-white dark:bg-darkBg relative w-full px-4 sm:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-7xl 3xl:max-w-6xl mx-auto md:rounded-3xl md:px-7 py-4 md:py-7 !pb-10 md:mb-10">
        {/* <div className="space-y-4 pb-4">
          <div className="relative shadow-md rounded-lg py-3 flex flex-col md:flex-row justify-between items-center gap-x-4 border border-slate-200 dark:border-gray-700 dark:bg-gray-700 px-2 md:px-4 divide-y md:divide-y-0 divide-slate-200">
            <div className="flex-shrink flex-grow w-full ">
              <SearchWithDropdown
                placeholder="Search jobs"
                keyword={keyword}
                setKeyword={setKeyword}
                xPlacement="bottom"
                divClasses="border-0 dark:text-gray-100"
                inputClasses="pr-24"
                icon="fa-light fa-search"
                iconClasses="text-black text-lg md:text-2xl dark:text-gray-100"
              />
            </div>
          </div>

          <div className="flex gap-3 flex-wrap">
            <div className="flex-shrink flex-grow w-full sm:w-auto">
              <Select
                placeholder="Experience Level"
                dropdownData={jobExperienceData?.data?.map((item) => ({
                  name: item?.content?.en?.title,
                  value: item?._id,
                }))}
                selectedValue={experience}
                onChange={(value) => setExperience(value)}
                xPlacement="bottom-right"
                dropdownClass="bg-white w-full"
                dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 "
              />
            </div>

            <div className="flex-shrink flex-grow w-full sm:w-auto">
              <Select
                placeholder="Job Type"
                dropdownData={jobTypeOptions}
                selectedValue={jobType}
                onChange={(value) => setJobType(value)}
                xPlacement="bottom-right"
                dropdownClass="bg-white w-full"
                dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 "
              />
            </div>

            <div className="flex-shrink flex-grow w-full sm:w-auto">
              <Select
                placeholder="Salary"
                dropdownData={salaryOptions}
                selectedValue={salary}
                onChange={(value) => setSalary(value)}
                xPlacement="bottom-right"
                dropdownClass="bg-white w-full"
                dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 "
              />
            </div>

            <div className="flex-shrink flex-grow w-full sm:w-auto">
              <Select
                placeholder="Skills"
                dropdownData={jobSkillData?.data?.map((item) => ({
                  name: item?.content?.en?.title,
                  value: item?._id,
                }))}
                selectedValue={skills}
                onChange={(value) => setSkills(value)}
                xPlacement="bottom-right"
                dropdownClass="bg-white w-full"
                dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 "
              />
            </div>
            <div className="flex-shrink-0 w-full sm:w-auto">
              <button
                type="button"
                onClick={handleResetFilters}
                className="flex items-center justify-center gap-2 px-5 py-2.5 bg-white dark:bg-white/30 dark:border-gray-500 dark:text-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-all rounded-lg shadow-sm font-medium text-sm sm:text-base"
              >
                <i className="fa-solid fa-rotate-left"></i>
                Reset
              </button>
            </div>
          </div>
        </div> */}

        {/* ---------------- CONTENT GRID ---------------- */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
          <div className={`space-y-5 md:col-span-5 ${showJobMobile ? "hidden md:block" : "block"}`}>
            <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row items-start gap-3 lg:items-center justify-between">
              <div className="flex-shrink flex-grow">
                <span className="text-black dark:text-gray-100 text-base md:text-lg font-bold">
                  Recommended jobs:{" "}
                </span>
                <span className="text-base md:text-lg text-gray-400 dark:text-gray-200">
                  {isFetching ? (
                    <>
                      <InlineSpinner />
                    </>
                  ) : (
                    (jobsData?.length ?? 0)
                  )}
                </span>
              </div>
              <div className="flex-shrink-0 flex-grow-0 fixed bottom-0 left-0 w-full z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 p-3 md:static md:w-auto md:bg-transparent md:border-0 md:p-0">
                <div className="flex items-center gap-2 justify-end">
                  <div className="flex-shrink flex-grow text-black dark:text-gray-100 text-sm md:text-base">
                    Sort by:
                  </div>
                  <div className="flex-shrink-0 flex-grow-0">
                    <Select
                      placeholder="Last Update"
                      dropdownData={sortOptions}
                      selectedValue={filters.sortQuery}
                      onChange={(value) => {
                        setFilters((prev) => ({
                          ...prev,
                          sortQuery: value,
                          page: 1,
                        }));
                      }}
                      xPlacement="bottom-right"
                      dropdownClass="bg-white"
                      dropdownButtonClass="w-full sm:w-36 dark:text-gray-100 dark:border-gray-700 dark:bg-gray-700 h-7 md:h-9"
                    />
                  </div>
                </div>
              </div>
            </div>

            {renderJobCards()}
            {totalPages > 1 && (
              <PaginationPage
                pageCount={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          {/* {isLoading || isFetching ? (
  <JobDetailsSkeleton /> // loader while list is fetching/filtering
) : jobsData.length === 0 ? (
  <JobDetailsCard jobDetails={null} /> // No jobs in list
) : isDetailsLoading ? (
  <JobDetailsSkeleton /> // loader while selected job details are fetching
) : (
  <JobDetailsCard
    jobDetails={jobDetails}
    onApplyClick={() => setIsModalOpen(true)}
  />
)} */}

          <div className={`relative md:col-span-7 ${showJobMobile ? "block" : "hidden md:block"} md:max-h-[calc(180vh-110px)] md:overflow-auto pr-0 xls:pr-2 scrollbar`}>

            <div className="px-4 md:px-5 py-4 md:py-5 border border-slate-200 dark:border-gray-500 dark:bg-white/10 rounded-md md:rounded-3xl overflow-hidden relative mb-5">
              {showJobMobile && (
                <button
                  onClick={() => setShowJobMobile(false)}
                  className="md:hidden flex items-center gap-2 mb-2 text-gray-500 dark:text-gray-200 hover:text-primaryColor transition"
                >
                  <i className="fa-solid fa-arrow-left text-sm"></i>
                  <span className="text-sm font-medium">Back</span>
                </button>
              )}

              {isDetailsLoading || isLoading || isFetching ? (
                <JobDetailsSkeleton />
              ) : (
                <>

                  <JobDetailsCard
                    jobDetails={jobDetails}
                    onApplyClick={() => setIsModalOpen(true)}
                  />
                </>
              )}
            </div>
            {/* <div className="px-4 md:px-5 py-4 md:py-5 border border-slate-200 dark:border-gray-500 dark:bg-white/10 rounded-md md:rounded-3xl overflow-hidden relative">
              <AboutCompany />
            </div> */}
          </div>
        </div>
      </section>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Application Form"
        size="xl4"
        closeBtn={true}
        backdrop={true}
        animation="slide"
        bodyClasses="!max-h-[calc(100vh-100px)] overflow-auto"
      >
        <Form
          onSubmit={submitApplication}
          handleSubmit={handleSubmit}
          loading={isPending}
        >
          <div className="space-y-4">
            <div className="relative space-y-4">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-2 capitalize">
                Application for Employment – {selectedJob?.subtitle}
              </div>

              <div className="relative space-y-2">
                <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium">
                  Please complete this form
                </div>

                <div className="text-base text-slate-500 dark:text-gray-300">
                  If you would like to upload your resume, you may do so below.
                </div>

                <FileUploadSingle
                  label=""
                  name="resume"
                  size="full"
                  accept=".pdf,.jpg,.jpeg,.png,.webp"
                  uploadSize={5}
                  placeholder="Drag and drop your resume here (PDF or Image)"
                  value={resumeFile}
                  onChange={(file) => setResumeFile(file)}
                  onRemove={() => setResumeFile(null)}
                />
              </div>

              <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Full Name"
                    inputName="firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    inputClasses={"h-14 rounded-xl"}
                    required
                    {...formValidate(errors, "firstName")}
                  />
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Address"
                    value={values.address}
                    onChange={handleChange}
                    inputClasses={"h-14 rounded-xl"}
                  />
                </div>

                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputType="number"
                    inputPlaceholder="Phone number"
                    inputName="phone"
                    value={values.phone}
                    onChange={handleChange}
                    required
                    {...formValidate(errors, "phone")}
                    inputClasses={"h-14 rounded-xl"}
                  />
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputType="number"
                    inputPlaceholder="Alternate Phone Number"
                    inputName="alternatePhone"
                    value={values.alternatePhone}
                    onChange={handleChange}
                    inputClasses="h-14 rounded-xl"
                  />
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputType="email"
                    inputPlaceholder="Email"
                    inputName="email"
                    value={values.email}
                    onChange={handleChange}
                    required
                    {...formValidate(errors, "email")}
                    inputClasses={"h-14 rounded-xl"}
                  />
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Targeted Position"
                    inputClasses={"h-14 rounded-xl"}
                    value={selectedJob?.title || ""}
                    isDisabled
                  />
                </div>
                <div className="col-span-12">
                  <DatePicker
                    label="Date Available to Start"
                    position="fixed"
                    placeholder="Select date"
                    className="rounded-xl"
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "dateAvailable",
                          value: e?.startDate || e?.endDate,
                        },
                      })
                    }
                    value={{
                      startDate: values?.dateAvailable,
                      endDate: values?.dateAvailable,
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <Input
                  inputType="number"
                  inputPlaceholder="Mon (Hours)"
                  inputName="monHours"
                  value={values.monHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Tue (Hours)"
                  inputName="tueHours"
                  value={values.tueHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Wed (Hours)"
                  inputName="wedHours"
                  value={values.wedHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Thu (Hours)"
                  inputName="thuHours"
                  value={values.thuHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Fri (Hours)"
                  inputName="friHours"
                  value={values.friHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Sat (Hours)"
                  inputName="satHours"
                  value={values.satHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />

                <Input
                  inputType="number"
                  inputPlaceholder="Sun (Hours)"
                  inputName="sunHours"
                  value={values.sunHours}
                  onChange={handleChange}
                  inputClasses="h-14 rounded-xl"
                />
              </div>

              {/* 
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                  (day) => (
                    <div key={day}>
                      <Input
                        inputType="number"
                        inputPlaceholder={`${day} (Hours)`}
                        inputName={`availability.${day}`}
                        value={values.availability?.[day]}
                        onChange={handleChange}
                        inputClasses="h-14 rounded-xl"
                      />
                    </div>
                  ),
                )}
              </div> */}

              <div className="grid grid-cols-1 mt-4">
                <Select
                  label="Are you willing to relocate?"
                  labelClasses="text-sm text-text-disabled"
                  placeholder="Relocate?"
                  dropdownData={[
                    { value: true, name: "Yes" },
                    { value: false, name: "No" },
                  ]}
                  selectedValue={values.willingToRelocate}
                  onChange={(value) =>
                    handleChange({
                      target: {
                        name: "willingToRelocate",
                        value,
                      },
                    })
                  }
                  xPlacement="bottom-right"
                  dropdownClass="bg-white w-full"
                  dropdownButtonClass="shadow-sm h-14 rounded-xl dark:bg-gray-200/20 dark:border-gray-500"
                />
              </div>
            </div>
            {/* ---------------- WORK EXPERIENCE ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-3">
                Work Experience — Most Recent First
              </div>

              <div className="border border-slate-200 dark:bg-gray-100/5 dark:border-gray-500 rounded-xl p-4 space-y-6">
                {(Array.isArray(values?.workExperience)
                  ? values.workExperience
                  : []
                ).map((exp, index) => {
                  const isFirst = index === 0;

                  return (
                    <div
                      key={index}
                      className="border border-slate-100 dark:border-gray-500 rounded-xl p-4 space-y-4"
                    >
                      <div className="flex items-center justify-between">
                        <div className="text-base font-semibold dark:text-gray-200">
                          {isFirst
                            ? "Current / Most Recent Employer"
                            : `Previous Employer (${index + 1})`}
                        </div>

                        {!isFirst && (
                          <button
                            type="button"
                            className="text-red-500 text-sm hover:underline"
                            onClick={() => {
                              const updated = values.workExperience.filter(
                                (_, i) => i !== index,
                              );
                              setFieldsValue({ workExperience: updated });
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-12 gap-4">
                        {/* Employer */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Employer Name"
                            value={exp.employer}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].employer = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* Job Title */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Job Title"
                            value={exp.jobTitle}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].jobTitle = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* Address */}
                        <div className="col-span-12">
                          <Textarea
                            inputPlaceholder="Full Address"
                            inputValue={exp.address.address1}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].address.address1 = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-24 rounded-xl"
                          />
                        </div>

                        {/* City */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="City"
                            value={exp.address.city}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].address.city = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* State */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="State"
                            value={exp.address.state}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].address.state = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* ZIP */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputType="number"
                            inputPlaceholder="ZIP Code"
                            value={exp.address.zipcode}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].address.zipcode = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* Phone */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputType="number"
                            inputPlaceholder="Phone"
                            value={exp.phone}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].phone = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* Start Date */}
                        <div className="col-span-12 lg:col-span-6">
                          <DatePicker
                            label="Start Date"
                            value={{
                              startDate: exp.startDate,
                              endDate: exp.startDate,
                            }}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].startDate =
                                e?.startDate || e?.endDate;
                              setFieldsValue({ workExperience: updated });
                            }}
                          />
                        </div>

                        {/* End Date */}
                        <div className="col-span-12 lg:col-span-6">
                          <DatePicker
                            label="End Date"
                            value={{
                              startDate: exp.endDate,
                              endDate: exp.endDate,
                            }}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].endDate =
                                e?.startDate || e?.endDate;
                              setFieldsValue({ workExperience: updated });
                            }}
                          />
                        </div>

                        {/* Supervisor */}
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Supervisor Name"
                            value={exp.supervisorName}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].supervisorName = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputType="number"
                            inputPlaceholder="Supervisor Phone"
                            value={exp.supervisorPhone}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].supervisorPhone = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        {/* Certifications */}
                        <div className="col-span-12">
                          <Textarea
                            inputPlaceholder="Certifications / Training while employed"
                            inputValue={exp.certifications}
                            onChange={(e) => {
                              const updated = [...values.workExperience];
                              updated[index].certifications = e.target.value;
                              setFieldsValue({ workExperience: updated });
                            }}
                            inputClasses="h-24 rounded-xl"
                          />
                        </div>

                        {/* Additional History (last employer only) */}
                        {index === values.workExperience.length - 1 && (
                          <div className="col-span-12">
                            <Textarea
                              inputPlaceholder="Additional or explanatory employment history"
                              inputValue={exp.additionalHistory || ""}
                              onChange={(e) => {
                                const updated = [...values.workExperience];
                                updated[index].additionalHistory =
                                  e.target.value;
                                setFieldsValue({ workExperience: updated });
                              }}
                              inputClasses="h-24 rounded-xl"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* ADD MORE */}
                <button
                  type="button"
                  className="text-sm text-primary font-medium hover:underline"
                  onClick={() =>
                    setFieldsValue({
                      workExperience: [
                        ...(Array.isArray(values.workExperience)
                          ? values.workExperience
                          : []),
                        {
                          employer: "",
                          jobTitle: "",
                          phone: "",
                          startDate: "",
                          endDate: "",
                          supervisorName: "",
                          supervisorPhone: "",
                          certifications: "",
                          additionalHistory: "",
                          address: {
                            address1: "",
                            city: "",
                            state: "",
                            zipcode: "",
                          },
                        },
                      ],
                    })
                  }
                >
                  + Add Previous Employer
                </button>
              </div>
            </div>

            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-2">
                Volunteer Work / Group Memberships
              </div>
              <Textarea
                inputPlaceholder="Describe any volunteer work or memberships"
                inputClasses="h-28 rounded-xl"
              />
            </div>
            {/* ---------------- EDUCATION ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-3">
                Education
              </div>

              <div className="border border-slate-200 dark:bg-gray-200/10 dark:border-gray-500 rounded-xl p-4 space-y-6">
                {(Array.isArray(values?.education) ? values.education : []).map(
                  (edu, index) => {
                    const isHighSchool = index === 0;

                    return (
                      <div
                        key={index}
                        className="border border-slate-100 dark:border-gray-500 rounded-xl p-4 space-y-4"
                      >
                        <div className="flex items-center justify-between">
                          <div className="text-base font-semibold dark:text-gray-200">
                            {isHighSchool
                              ? "High School"
                              : `Institution (${index})`}
                          </div>

                          {!isHighSchool && (
                            <button
                              type="button"
                              className="text-red-500 text-sm hover:underline"
                              onClick={() => {
                                const updated = values.education.filter(
                                  (_, i) => i !== index,
                                );
                                setFieldsValue({ education: updated });
                              }}
                            >
                              Remove
                            </button>
                          )}
                        </div>

                        {/* HIGH SCHOOL */}
                        {isHighSchool ? (
                          <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12">
                              <Input
                                inputPlaceholder="Name & Location of High School"
                                value={edu.instituteName}
                                onChange={(e) => {
                                  const updated = [...values.education];
                                  updated[0].instituteName = e.target.value;
                                  setFieldsValue({ education: updated });
                                }}
                                inputClasses="h-14 rounded-xl"
                              />
                            </div>

                            <div className="col-span-12 lg:col-span-6">
                              <Select
                                placeholder="Diploma or GED?"
                                dropdownData={[
                                  { name: "Diploma", value: "Diploma" },
                                  { name: "GED", value: "GED" },
                                ]}
                                selectedValue={edu.type}
                                onChange={(value) => {
                                  const updated = [...values.education];
                                  updated[0].type = value;
                                  setFieldsValue({ education: updated });
                                }}
                                dropdownButtonClass="h-14 rounded-xl"
                              />
                            </div>

                            <div className="col-span-12 lg:col-span-6">
                              <Input
                                inputPlaceholder="Year Received"
                                value={edu.yearPass}
                                onChange={(e) => {
                                  const updated = [...values.education];
                                  updated[0].yearPass = e.target.value;
                                  setFieldsValue({ education: updated });
                                }}
                                inputClasses="h-14 rounded-xl"
                              />
                            </div>

                            <div className="col-span-12">
                              <Textarea
                                inputPlaceholder="Additional training, certifications, security clearance"
                                inputValue={edu.notes}
                                onChange={(e) => {
                                  const updated = [...values.education];
                                  updated[0].notes = e.target.value;
                                  setFieldsValue({ education: updated });
                                }}
                                inputClasses="h-24 rounded-xl"
                              />
                            </div>
                          </div>
                        ) : (
                          /* INSTITUTIONS */
                          <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 lg:col-span-6">
                              <Input
                                inputPlaceholder="Name & Location"
                                value={edu.instituteName}
                                onChange={(e) => {
                                  const updated = [...values.education];
                                  updated[index].instituteName = e.target.value;
                                  setFieldsValue({ education: updated });
                                }}
                                inputClasses="h-14 rounded-xl"
                              />
                            </div>

                            <div className="col-span-12 lg:col-span-6">
                              <Input
                                inputPlaceholder="Degree / Field of Study"
                                value={edu.degree}
                                onChange={(e) => {
                                  const updated = [...values.education];
                                  updated[index].degree = e.target.value;
                                  setFieldsValue({ education: updated });
                                }}
                                inputClasses="h-14 rounded-xl"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  },
                )}

                {/* ADD MORE INSTITUTION */}
                <button
                  type="button"
                  className="text-sm text-primary font-medium hover:underline"
                  onClick={() =>
                    setFieldsValue({
                      education: [
                        ...values.education,
                        {
                          level: "institution",
                          instituteName: "",
                          degree: "",
                        },
                      ],
                    })
                  }
                >
                  + Add Institution
                </button>
              </div>
            </div>

            {/* ---------------- PROFESSIONAL REFERENCES ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-3">
                Professional References (Minimum of Three)
              </div>

              <div className="space-y-4">
                {(Array.isArray(values?.references)
                  ? values.references
                  : []
                ).map((ref, index) => {
                  const canRemove = index >= 3;

                  return (
                    <div
                      key={index}
                      className="border border-slate-200 dark:bg-gray-200/10 dark:border-gray-500 rounded-xl p-4 space-y-4"
                    >
                      <div className="flex items-center justify-between">
                        <div className="text-base font-semibold dark:text-gray-200">
                          Reference {index + 1}
                        </div>

                        {canRemove && (
                          <button
                            type="button"
                            className="text-red-500 text-sm hover:underline"
                            onClick={() => {
                              const updated = values.references.filter(
                                (_, i) => i !== index,
                              );
                              setFieldsValue({ references: updated });
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-12 gap-4 md:gap-6">
                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Name"
                            value={ref.name}
                            onChange={(e) => {
                              const updated = [...values.references];
                              updated[index].name = e.target.value;
                              setFieldsValue({ references: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Relationship"
                            value={ref.relationship}
                            onChange={(e) => {
                              const updated = [...values.references];
                              updated[index].relationship = e.target.value;
                              setFieldsValue({ references: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        <div className="col-span-12 lg:col-span-6">
                          <Input
                            inputPlaceholder="Company / Title"
                            value={ref.title}
                            onChange={(e) => {
                              const updated = [...values.references];
                              updated[index].title = e.target.value;
                              setFieldsValue({ references: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        <div className="col-span-12 lg:col-span-3">
                          <Input
                            inputType="number"
                            inputPlaceholder="Phone"
                            value={ref.phone}
                            onChange={(e) => {
                              const updated = [...values.references];
                              updated[index].phone = e.target.value;
                              setFieldsValue({ references: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>

                        <div className="col-span-12 lg:col-span-3">
                          <Input
                            inputType="email"
                            inputPlaceholder="Email"
                            value={ref.email}
                            onChange={(e) => {
                              const updated = [...values.references];
                              updated[index].email = e.target.value;
                              setFieldsValue({ references: updated });
                            }}
                            inputClasses="h-14 rounded-xl"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* ADD MORE */}
                <button
                  type="button"
                  className="text-sm text-primary font-medium hover:underline"
                  onClick={() =>
                    setFieldsValue({
                      references: [
                        ...values.references,
                        {
                          name: "",
                          relationship: "",
                          title: "",
                          phone: "",
                          email: "",
                        },
                      ],
                    })
                  }
                >
                  + Add Reference
                </button>
              </div>
            </div>

            {/* ---------------- EXPECTED SALARY ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-2">
                Expected Salary Range
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Expected Salary (e.g. $60,000 – $75,000)"
                    inputClasses="h-14 rounded-xl"
                  />
                </div>
              </div>
            </div>

            {/* ---------------- IDENTIFICATION ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-3">
                Identification
              </div>

              <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Driver’s License Number"
                    inputClasses="h-14 rounded-xl"
                  />
                </div>

                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="State Issued"
                    inputClasses="h-14 rounded-xl"
                  />
                </div>

                <div className="col-span-12 lg:col-span-6">
                  <Input
                    inputPlaceholder="Passport ID (if applicable)"
                    inputClasses="h-14 rounded-xl"
                  />
                </div>
              </div>
            </div>

            {/* ---------------- SOFT SKILLS ---------------- */}
            <div className="relative">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium mb-3">
                Soft Skills & Values
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Textarea
                  inputPlaceholder="Describe one time you disagreed with a teammate and how the issue was resolved:"
                  inputName="softSkill_0"
                  inputValue={values.softSkill_0}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="What did you teach yourself outside your role in the last 12 months, and how did you apply it?"
                  inputName="softSkill_1"
                  inputValue={values.softSkill_1}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Describe a time you reported a risky practice at work and the outcome:"
                  inputName="softSkill_2"
                  inputValue={values.softSkill_2}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="If instructed to skip a due-diligence step to meet a deadline, what would you do?"
                  inputName="softSkill_3"
                  inputValue={values.softSkill_3}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Rate 1-5 ability to stay productive without supervision and explain one tactic:"
                  inputName="softSkill_4"
                  inputValue={values.softSkill_4}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Give an example of tailoring communication to help a non-technical colleague:"
                  inputName="softSkill_5"
                  inputValue={values.softSkill_5}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Recent project mistake and first corrective action:"
                  inputName="softSkill_6"
                  inputValue={values.softSkill_6}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Single opening sentence to ask resources from an overloaded team:"
                  inputName="softSkill_7"
                  inputValue={values.softSkill_7}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Describe escalating a concern others had not noticed:"
                  inputName="softSkill_8"
                  inputValue={values.softSkill_8}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />

                <Textarea
                  inputPlaceholder="Professional goal you set and progress to-date:"
                  inputName="softSkill_9"
                  inputValue={values.softSkill_9}
                  onChange={handleChange}
                  inputClasses="h-24 rounded-xl"
                />
              </div>
            </div>

            {/* ---------------- CONFIDENTIAL ---------------- */}
            {/* <div className="relative space-y-4">
            <div className="text-black text-lg xls:text-xl font-medium">
              Confidential – Voluntary Self-Identification
            </div>
            <div className="grid grid-cols-1 gap-4">
              <Checkbox
                checkboxName="terms"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                checkboxLabel="I agree to the terms and conditions"
              />
            </div>
            <div className="grid grid-cols-1 gap-4">
              <Radio
                id="male"
                radioName="gender"
                value="male"
                isChecked={gender === "male"}
                onChange={(e) => setGender(e.target.value)}
                radioLabel="Male"
              />
            </div>
          </div> */}
            {/* ---------------- CONFIDENTIAL SELF IDENTIFICATION ---------------- */}
            <div className="relative space-y-6">
              <div className="text-black dark:text-gray-200 text-lg xls:text-xl font-medium">
                Confidential – Voluntary Self-Identification
              </div>

              <div className="text-sm text-slate-500 dark:text-gray-300">
                Federal compliance – responses remain confidential and are used
                only for government reporting purposes.
              </div>

              {/* -------- EEO CLASSIFICATION -------- */}
              <div className="space-y-3">
                <div className="text-base font-semibold relative dark:text-gray-200">
                  1. EEO Classification (check one or more)
                  <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                    <i className="fa-solid fa-asterisk"></i>
                  </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Checkbox
                    checkboxName="eeo"
                    value="Hispanic or Latino"
                    checkboxLabel="Hispanic or Latino"
                    checked={eeo.includes("Hispanic or Latino")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="White"
                    checkboxLabel="White"
                    checked={eeo.includes("White")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="Black / African-American"
                    checkboxLabel="Black / African-American"
                    checked={eeo.includes("Black / African-American")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="Asian"
                    checkboxLabel="Asian"
                    checked={eeo.includes("Asian")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="Native Hawaiian / Pacific Islander"
                    checkboxLabel="Native Hawaiian / Pacific Islander"
                    checked={eeo.includes("Native Hawaiian / Pacific Islander")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="American Indian / Alaska Native"
                    checkboxLabel="American Indian / Alaska Native"
                    checked={eeo.includes("American Indian / Alaska Native")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="Two or More Races"
                    checkboxLabel="Two or More Races"
                    checked={eeo.includes("Two or More Races")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />

                  <Checkbox
                    checkboxName="eeo"
                    value="Prefer not to answer"
                    checkboxLabel="Prefer not to answer"
                    checked={eeo.includes("Prefer not to answer")}
                    onChange={(e) =>
                      setEeo((prev) =>
                        e.target.checked
                          ? [...prev, e.target.value]
                          : prev.filter((v) => v !== e.target.value),
                      )
                    }
                  />
                </div>
              </div>

              {/* -------- SEX -------- */}
              <div className="space-y-3">
                <div className="text-base font-semibold relative dark:text-gray-200">
                  2. Sex
                  <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                    <i className="fa-solid fa-asterisk"></i>
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Radio
                    radioName="sex"
                    value="male"
                    radioLabel="Male"
                    isChecked={sex === "male"}
                    onChange={(e) => setSex(e.target.value)}
                  />

                  <Radio
                    radioName="sex"
                    value="female"
                    radioLabel="Female"
                    isChecked={sex === "female"}
                    onChange={(e) => setSex(e.target.value)}
                  />

                  <Radio
                    radioName="sex"
                    value="non-binary"
                    radioLabel="Non-binary"
                    isChecked={sex === "non-binary"}
                    onChange={(e) => setSex(e.target.value)}
                  />

                  <Radio
                    radioName="sex"
                    value="not-to-say"
                    radioLabel="Prefer not to say"
                    isChecked={sex === "not-to-say"}
                    onChange={(e) => setSex(e.target.value)}
                  />
                </div>
              </div>

              {/* -------- VETERAN STATUS -------- */}
              <div className="space-y-3">
                <div className="text-base font-semibold relative dark:text-gray-200">
                  3. Veteran Status
                  <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                    <i className="fa-solid fa-asterisk"></i>
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Radio
                    radioName="veteranStatus"
                    value="veteran"
                    radioLabel="I identify as one or more protected veteran classifications"
                    isChecked={veteranStatus === "veteran"}
                    onChange={(e) => setVeteranStatus(e.target.value)}
                  />

                  <Radio
                    radioName="veteranStatus"
                    value="not-veteran"
                    radioLabel="Not a veteran"
                    isChecked={veteranStatus === "not-veteran"}
                    onChange={(e) => setVeteranStatus(e.target.value)}
                  />

                  <Radio
                    radioName="veteranStatus"
                    value="not-to-say"
                    radioLabel="Choose not to self-identify"
                    isChecked={veteranStatus === "not-to-say"}
                    onChange={(e) => setVeteranStatus(e.target.value)}
                  />
                </div>
              </div>

              {/* -------- DISABILITY STATUS -------- */}
              <div className="space-y-3">
                <div className="text-base font-semibold relative dark:text-gray-200">
                  Disability Status (Section 503)
                  <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                    <i className="fa-solid fa-asterisk"></i>
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Radio
                    radioName="disability"
                    value="yes"
                    radioLabel="Yes – I have a disability"
                    isChecked={disability === "yes"}
                    onChange={(e) => setDisability(e.target.value)}
                  />

                  <Radio
                    radioName="disability"
                    value="no"
                    radioLabel="No – I do not have a disability"
                    isChecked={disability === "no"}
                    onChange={(e) => setDisability(e.target.value)}
                  />

                  <Radio
                    radioName="disability"
                    value="not-to-say"
                    radioLabel="Prefer not to answer"
                    isChecked={disability === "not-to-say"}
                    onChange={(e) => setDisability(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* ---------------- SIGNATURE ---------------- */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <Input
                  inputPlaceholder="Signature (Full Name)"
                  inputName="signature"
                  value={values.signature}
                  onChange={handleChange}
                  required
                  {...formValidate(errors, "signature")}
                  inputClasses="h-14 rounded-xl"
                />
              </div>
              <div className="col-span-12">
                <DatePicker
                  label="Date"
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "signatureDate",
                        value: e?.startDate || e?.endDate,
                      },
                    })
                  }
                  value={{
                    startDate: values.signatureDate,
                    endDate: values.signatureDate,
                  }}
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-end gap-2">
              <Button
                buttonLabel="Cancel"
                buttonClasses="bg-transparent text-white h-12 px-11 rounded-lg hover:bg-transparent border border-slate-200 sm:w-auto w-full dark:bg-gray-500 dark:border-gray-500"
                buttonFunction={() => setIsModalOpen(false)}
                buttonLabelClasses={
                  "text-slate-700 font-bold dark:text-gray-100"
                }
              />
              <Button
                buttonLabel="Apply now"
                buttonClasses="bg-palatte5 hover:bg-transparent border border-palatte5 dark:border-palatte5 text-white h-12 px-11 rounded-lg hover:bg-palatte5 sm:w-auto w-full"
                buttonType="submit"
                loading={isPending}
                isDisable={isPending}
                buttonLabelClasses={"text-white font-bold"}
              />
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

const JobCardSkeleton = () => {
  return (
    <div className="animate-pulse p-4 border border-slate-200 rounded-lg">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-16 h-16 bg-slate-200 rounded-lg"></div>
        <div className="flex-grow space-y-2">
          <div className="h-5 bg-slate-200 rounded w-3/4"></div>
          <div className="h-4 bg-slate-200 rounded w-1/2"></div>
          <div className="h-3 bg-slate-200 rounded w-full"></div>
          <div className="flex gap-2 mt-2">
            <div className="h-6 bg-slate-200 rounded w-20"></div>
            <div className="h-6 bg-slate-200 rounded w-20"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSection;
